export default __webpack_public_path__ + "static/media/Specyfikacja_Click&Link_Cubo_kids.9465b4c1.pdf";